import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkmark\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8047 3.52864C14.0651 3.78899 14.0651 4.2111 13.8047 4.47145L6.4714 11.8048C6.21106 12.0651 5.78894 12.0651 5.5286 11.8048L2.19526 8.47145C1.93491 8.2111 1.93491 7.78899 2.19526 7.52864C2.45561 7.26829 2.87772 7.26829 3.13807 7.52864L6 10.3906L12.8619 3.52864C13.1223 3.26829 13.5444 3.26829 13.8047 3.52864Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol